module.exports = __webpack_public_path__ + "img/three_news.4a1cf502.png";